import AppWrapper from "../../components/cm/AppWrapper";
import SideBarMain from "../../components/cm/SideBarMain";
import ProviderClientSearch from "../../components/modules/ProviderClientSearch";

export default () => {
  return (
    <AppWrapper.WithSidebar sidebar={<SideBarMain />}>
      <ProviderClientSearch />
    </AppWrapper.WithSidebar>
  );
};
